module.exports = __webpack_public_path__ + "img/error-illustration.02eb8c28.svg";